import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base.service';
import { lastValueFrom } from 'rxjs';
import { WhatsappTemplate } from 'src/app/models/notificacion/whatsapp_template.model';


@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateService extends BaseService {

    
    recordName = 'whatsapp_templates';
    
    url = `${ environment.host }/whatsapp-template`;

    codigoModulo = WhatsappTemplate.CODIGO_MODULO;
    codigoRegistro = WhatsappTemplate.CODIGO_REGISTRO;

    async listByCompany(idEmpresa: number, size: number, filters: Record<string, any>[] = []): Promise<any> {
        const companyId = Number(idEmpresa || 0);

        if (!companyId) {
            return {
                ok: true,
                msg: 'Empresa no seleccionada',
                resp: { rows: [], count: 0 },
            };
        }

        return this.getAll(size, {
            filters: [
                { field: 'id_empresa', type: 'id', value: companyId },
                ...filters,
            ],
        });
    }

    async sincronizarEstado(idTemplate: number, idEmpresa: number): Promise<any> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify([{ field: 'id_empresa', type: 'id', value: idEmpresa }]);
            const url = `${this.url}/${idTemplate}/sync-status`;
            return await lastValueFrom(this.http.get<any>(url, { headers: this.header }));
        } catch (error: any) {
            return this.checkError(error);
        }
    }

}
